export const generateLastThreeMonths = () => {
  const firstDate = new Date().setDate(new Date().getDate() - 90);
  const [firstDateInIso] = new Date(firstDate).toISOString().split('T');

  const secondDate = new Date().setDate(new Date().getDate() - 61);
  const [secondDateInIso] = new Date(secondDate).toISOString().split('T');

  const thirdDate = new Date().setDate(new Date().getDate() - 60);
  const [thirdDateInIso] = new Date(thirdDate).toISOString().split('T');

  return {
    firstDateInIso,
    secondDateInIso,
    thirdDateInIso,
  };
};
